import css from './PageLoader.module.scss'

const PageLoader = () => (
  <div className={css.LoaderBkg}>
    <div className={css.Loader}></div>
    <div className={css.GamePad}>
      <i className='fa-solid fa-gamepad'></i>
    </div>
  </div>
)

export default PageLoader
